import React from "react";

export default function TermsOfUse() {
  return (
    <div
      style={{
        margin: "80px",
        marginTop: "25px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "900px",
      }}
    >
      <>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
        <title>Hi</title>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n\t\t\tbody { font-family:Calibri; font-size:12pt }\n\t\t\th1, h2, p { margin:0pt }\n\t\t\tli { margin-top:0pt; margin-bottom:0pt }\n\t\t\th1 { margin-top:5pt; margin-bottom:5pt; page-break-inside:auto; page-break-after:auto; font-family:'Times New Roman'; font-size:24pt; font-weight:bold; color:#000000 }\n\t\t\th2 { margin-top:5pt; margin-bottom:5pt; page-break-inside:auto; page-break-after:auto; font-family:'Times New Roman'; font-size:18pt; font-weight:bold; color:#000000 }\n\t\t\t.NormalWeb { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.col-12 { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.mb-0 { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.mb-050 { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.mb-1 { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.mb-4 { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\t.sa-li { margin-top:5pt; margin-bottom:5pt; font-family:'Times New Roman'; font-size:12pt }\n\t\t\tspan.Emphasis { font-style:italic }\n\t\t\tspan.Heading1Char { font-family:'Times New Roman'; font-size:24pt; font-weight:bold }\n\t\t\tspan.Heading2Char { font-family:'Times New Roman'; font-size:18pt; font-weight:bold }\n\t\t\tspan.Hyperlink { text-decoration:underline; color:#0000ff }\n\t\t\tspan.Strong { font-weight:bold }\n\t\t",
          }}
        />
        <p style={{ marginBottom: "14pt", fontSize: "24pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>BrandGen Platform Terms of Use</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The "Agreement," which includes these Platform Terms of Use, the BrandGen Privacy Policy, and any additional
            policies, addenda, and notices provided to you, sets the terms of your relationship as the "Company" with
            BrandGen Inc. ("BrandGen"). This Agreement applies to the Platform (defined later) offered by BrandGen,
            accessible through the BrandGen website (the "Site") or any BrandGen application (the "App"), including but
            not limited to BrandGen.io and any future websites or mobile applications operated by BrandGen. The
            "Effective Date" is the date you first access your Account (as defined later). Please read these BG Platform
            Terms of Use carefully and be sure you fully understand the terms and conditions. The Agreement constitutes
            a binding legal agreement between you and BrandGen Inc.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Your use of the BG Platform constitutes your agreement to all such terms, conditions, and notices in effect
            at such time. You hereby represent and warrant that (i) you are lawfully able to enter into and perform a
            legally binding contract, (ii) if you are entering the Agreement on behalf of your employer and you are
            authorized to do so, and (iii) agree to be bound by the Agreement. Please retain a copy of the Agreement for
            your records.
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          It's also important to review the BrandGen Privacy Policy, which is an integral part of the Agreement and can
          be found on the Site. If you are not willing to comply with all terms of the Agreement, including the BrandGen
          Privacy Policy, you should refrain from accessing or using the Platform through the Site.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen reserves the right to make updates or changes to the Agreement, including the BrandGen Privacy Policy
          and any other related policies and notices pertaining to the Platform. It is your responsibility to regularly
          review the Agreement. While you have the choice to accept or reject the revised Agreement, your acceptance of
          the updated Agreement is necessary for continued use of the Platform.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          To acknowledge your consent to any updated version of the Agreement, you might need to select "accept" or
          "agree." If you disagree with the terms of the Agreement or any of its revised versions, your only option is
          to stop using the Platform, resulting in loss of access to your Account (as detailed below). BrandGen
          specifies that the use of the Platform is governed by the Agreement version in force at the time of use,
          unless explicitly stated otherwise.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>1. The Platform</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen provides an online platform along with associated services (collectively, the "Platform"), enabling
          the Company to purchase, monitor, and manage digital media ("Media") for distributing its native, display,
          video, audio, Connected TV, in-game, and DOOH advertisements ("Ads"). The Platform, powered by BrandGen's
          unique data driven technology, curates audiences and bids on Media based on the Company's specific criteria
          and offers both manual and automated options to achieve the Company's advertising goals. BrandGen reserves the
          right to review and approve all Ads. In its sole discretion, BrandGen may refuse to publish any Ad that is
          deemed technically subpar, illegal, harmful, threatening, abusive, harassing, tortious, defamatory, vulgar,
          pornographic, obscene, libelous, an invasion of privacy, hateful, or discriminatory in any way.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2. Right to Access and Use the Platform</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.1 Right to Use</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Under the Agreement's terms and conditions, including the payment of relevant fees, BrandGen grants the
          Company a non-exclusive, non-transferable, and revocable right to access and use the Platform. This grant
          starts from the Effective Date and continues throughout the Term (defined later), in line with the Agreement's
          provisions, and includes usage on behalf of the Company's clients.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.2 Restrictions on Use</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen retains all rights not expressly granted in this document. The Company is prohibited from, and must
          ensure that no one else:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          a. Uses the Platform for any purpose other than executing the Agreement.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          b. Re-licenses, sub-licenses, leases, loans, or distributes the Platform to any third party.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          c. Operates a service bureau using the Platform.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          d. Reverse engineers, decompiles, disassembles, translates, or tries to access the source code of any software
          BrandGen uses to provide the Platform (referred to as "Software").
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          e. Alters, hides, or removes any copyright, trademark, or other proprietary notices in the Software.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.3 Reservation of Rights</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen maintains ownership of all intellectual property rights related to the Platform, including any
          associated documentation, technology, and any improvements or modifications made to it. Neither party is
          permitted to use the trademarks or trade names of the other without explicit permission.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.4 Audit Rights</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen holds the authority to oversee and audit the use of the Platform by the Company and its authorized
          users. This is primarily to verify compliance with the terms of the Agreement. Audits may be conducted by
          BrandGen or an authorized third party on BrandGen's behalf, and will be at BrandGen's expense.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.5 Accounts</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          To access and use the Platform, the Company is required to set up an account ("Account") and log in with a
          corporate email address. In future releases, the Company can establish one or several administrator accounts
          ("Admin Account(s)") for designated individuals ("Administrator(s)"). Once registered, an Administrator has
          the ability to grant platform access to other Company employees, directors, officers, contractors, or agents
          (together referred to as "Representatives"). BrandGen holds no responsibility for the distribution of further
          user access; all requests for such access must be directed to a designated Administrator.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.6 Security</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            BrandGen employs and upholds industry-standard security measures to prevent and detect any unauthorized
            access or use of the Platform and the Company's Ads. The Company recognizes and agrees that despite these
            security protocols, it's possible that unauthorized electronic intruders might still gain access to the
            Platform via the internet or other electronic means. Beyond maintaining these industry-standard safeguards
            to hinder unauthorized access, BrandGen is not liable and expressly disclaims any responsibility for actions
            taken by any unauthorized electronic intruder.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>2.7 Maintenance</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Occasionally, BrandGen needs to conduct maintenance on its system, which may involve routine tasks to
            maintain the Platform's availability, or upgrading, updating, or enhancing its system. BrandGen will make
            commercially reasonable efforts to schedule this maintenance at times that minimize any disruption to the
            Company's access. Whenever possible, BrandGen will inform the Company in advance of any planned maintenance.
            This notification will be provided either through a message on its website or via email to the Company's
            designated representative, detailing the timing and expected duration of the maintenance.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3. Company's Rights and Obligations</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3.1 Company's Responsibilities</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          As part of its obligations under the Agreement, the Company shall:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          a. Manage, support, and maintain its own systems, including computer hardware and software, required to access
          the Platform.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          b. Secure and uphold communication channels, including high-speed internet connections, between the Company's
          systems and BrandGen's system.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          c. Oversee the issuance and usage of all authorized users.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          d. Utilize the Platform strictly in accordance with the Agreement's terms.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          e. Adhere to all relevant legal, regulatory requirements, and BrandGen's policies concerning the use of the
          Platform and Ads delivered or served through it. This includes:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "72pt", marginBottom: "14pt" }}>
          i. Ensuring neither the Company nor any individual or entity controlling a 25% or more stake in the Company is
          identified under international economic sanctions as per applicable laws.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "72pt", marginBottom: "14pt" }}>
          ii. Confirming that no transactions with the Company are forbidden or limited under laws related to human
          trafficking, modern slavery, anti-money laundering, and terrorist financing.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          f. Guarantee that all Ads approved by the Company for use on the Platform comply with all applicable legal and
          regulatory requirements.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3.2 Company's Negative Covenants</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>Company shall not:</span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          a. Utilize the Platform for inappropriate or illegal activities;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          b. Engage in actions that place an excessive or disproportionately large burden on BrandGen's system;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          c. Employ the Platform or its software to create derivative works or software that is functionally similar or
          competitive; or
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          d. Replicate or download any software that BrandGen uses to deliver the Platform and that resides within
          BrandGen's system.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            In the case of data which may be provided by or provisioned through BrandGen, Company shall not:
          </span>
        </p>
        <ol start={5} style={{ margin: "0pt", paddingLeft: "0pt", listStyleType: "lower-latin" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "31.33pt",
              paddingLeft: "4.67pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            resell, rent, lease, sublicense, or transfer such data to any third-party;
          </li>
          <li
            style={{
              marginLeft: "30pt",
              paddingLeft: "6pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            use such data in any manner except for marketing purposes and the delivery of online advertisements; or
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "14pt",
              paddingLeft: "4pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            merge or combine such data with personally identifiable information.
          </li>
        </ol>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3.3 Representations and Warranties of Company</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            In addition, Company represents, warrants and covenants that:
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Ads delivered or displayed through the Platform will exclude materials or links to materials that:
        </p>
        <ol start={9} style={{ margin: "0pt", paddingLeft: "0pt", listStyleType: "lower-latin" }}>
          <li
            className="NormalWeb"
            style={{
              marginTop: "14pt",
              marginLeft: "29.33pt",
              marginBottom: "14pt",
              paddingLeft: "6.67pt",
            }}
          >
            Are illegal, harmful, spam-like, threatening, harassing, abusive, defamatory, vulgar, obscene,
            privacy-invading, hateful, discriminatory, biased, or in any way objectionable; or
          </li>
        </ol>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          ii. Infringe upon or misappropriate patents, copyrights, trademarks, trade secrets, or other intellectual
          property rights of any individual or entity; and
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          iii. None of the Ads will contain viruses, Trojan horses, worms, or other malicious elements designed to harm,
          disrupt, intercept, or unlawfully access any system.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3.4 Ownership of and License to Use Ads</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The Company maintains ownership of all intellectual property rights associated with the Ads and any related
            advertising materials supplied to BrandGen. The Company grants BrandGen the right and license to distribute
            and market its Ads via the Platform. Additionally, the Company authorizes BrandGen to use the Company's Ads
            and any of the Company's trademarks, trade names, service marks, logos, character names, and other
            intellectual property in relation to the Company's use of the Platform.
          </span>
          <br />
          <br />

          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>3.5 Ownership of Ads Created by BrandGen</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen assigns to the Company the ownership of all intellectual property rights for any Ads created by
          BrandGen based on the Company's directives. The Company, in turn, gives BrandGen the right and license to
          distribute and market these Ads via the Platform. Additionally, the Company permits and licenses BrandGen to
          utilize these Ads and any of the Company's trademarks, trade names, service marks, logos, character names, and
          other intellectual property in the context of the Company's use of the Platform.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4. Fees, Invoicing, and Payment</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.1 Fees</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Company shall pay BrandGen all fees, amounts and charges in relation to the cost of all Media, segment data
            and company data purchased by the Company through the Platform (the{" "}
          </span>
          <em>
            <span style={{ fontFamily: '"Times New Roman"' }}>"Fees"</span>
          </em>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            ). The Fees do not include applicable taxes. Fees are in the currency specified by the Company in the
            Company's Account.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.2 Invoices</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            If Company and BrandGen have executed a Preferred Agreement (a{" "}
          </span>
          <em>
            <span style={{ fontFamily: '"Times New Roman"' }}>"PA"</span>
          </em>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            ) pursuant to which Company has been approved by BrandGen for a credit limit and monthly billing, BrandGen
            shall send Company monthly invoices detailing Company's advertising campaign activities and amounts due for
            the previous month's advertising campaigns in accordance with BrandGen's invoice terms set forth on the
            invoice. BrandGen's analytics system shall be the sole basis of measurement for the purpose of determining
            the Fees. All invoices will be considered accepted by Company unless Company notifies BrandGen to the
            contrary in writing within 15 days after delivery of the applicable invoice. If Company has not entered into
            a PA, BrandGen will not provide a monthly invoice unless requested by Company.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.3 Payment</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Unless the Company has entered into a Preferred Agreement, Company shall pay the Fees with the credit card
            associated with Company's BrandGen account and the Fees will be charged to Company's credit card reflective
            of the media and account fees associated with the campaign(s) being run by the Company.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.4 Currency</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>All Fees are to be paid in USD.</span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.5 Taxes</span>
          </strong>
        </p>
        <ol style={{ margin: "0pt", paddingLeft: "0pt", listStyleType: "lower-latin" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "31.33pt",
              paddingLeft: "4.67pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            Company shall pay any and all taxes and fees that are paid or payable as a result of or otherwise in
            connection with the transactions contemplated in the Agreement including federal, state and local, excise,
            sales, use, goods and services, harmonized, value added and any taxes or other amounts in lieu thereof
            (collectively <em>"taxes"</em>), except for any non-value add taxes based on BrandGen's gross receipts.
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "14pt",
              paddingLeft: "4pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            Fees do not include any taxes which are or may be imposed by law on BrandGen, Company or their affiliate,
            irrespective of whether BrandGen needs to collect said taxes or Company is required to account for said
            taxes and remit them, by any taxing authority or jurisdiction occasioned by, relating to or as a result of
            the execution of the Agreement or any other matter, good or service provided for under or in connection with
            the Agreement.
          </li>
        </ol>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.6 Interest on Late Payments</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          If the Company does not make a payment as stipulated in the Agreement, BrandGen is entitled, in addition to
          any other rights or remedies it may have, to impose and the Company is obligated to pay interest on such
          overdue amounts. This interest is set at a rate of one percent (1%) per month, calculated daily and compounded
          monthly, amounting to an annual rate of 12%. This interest applies both before and after any court judgment
          regarding the overdue payment, starting from the date the payment was originally due.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>4.7 Credit</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The Company acknowledges and agrees that BrandGen may acquire consumer or other credit reports containing
            factual information as part of the application process. Furthermore, the Company authorizes the receipt and
            exchange of credit information related to this process.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>5. Privacy and Data</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>5.1 Privacy</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>The BrandGen Privacy Policy (available at </span>
          <a href="https://app.brandgen.io/privacy-policy" style={{ textDecoration: "none" }}>
            <u>
              <span style={{ fontFamily: '"Times New Roman"', color: "#0000ff" }}>
                https://app.brandgen.io/privacy-policy
              </span>
            </u>
          </a>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            ) applies to the collection, use and disclosure of any personal information that Company or users may
            provide to BrandGen. The parties shall comply with any laws and regulations pertaining to the privacy
            protection of personal information. Each party shall reasonably cooperate with the other party's specific
            requests as necessary to facilitate such party's compliance with any applicable privacy laws and
            regulations.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>5.2 Company's Responsibilities</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company is entirely responsible for all data it sends to BrandGen and any data collected by BrandGen on
          behalf of or in relation to the Company under the Agreement, including personal information ("Company Data").
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company guarantees that any Company Data it transfers to BrandGen will have been processed lawfully in
          compliance with applicable data privacy laws. Specifically, the Company assures that it will secure opt-in
          consent from data subjects as required by data privacy laws for the use of any BrandGen trackers, such as
          conversion pixels, retargeting pixels, or look-alike pixels.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company must also clearly identify any Company Data that originates from the European Union, European
          Economic Area, Switzerland, or the United Kingdom ("EU Company Data") to BrandGen. The Company understands
          that failing to correctly identify EU Company Data will lead to BrandGen rejecting any associated bid requests
          and the receipt of the EU Company Data.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company recognizes that BrandGen's ability to meet its obligations under the Agreement depends on the
          Company fulfilling its own responsibilities under data privacy laws. Should the Company become aware of or
          suspect any issues or violations regarding its obligations in this section, it is obliged to inform BrandGen
          immediately.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>5.3 Processing and Sub-processing</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Regarding Company Data, both BrandGen and the Company acknowledge that the Company acts as a data controller
          and BrandGen as a data processor.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen will process Company Data on the Company’s behalf in line with the BrandGen Privacy Policy. BrandGen
          is committed to adhering to the Company’s reasonable, documented instructions concerning the processing of
          Company Data. If BrandGen believes that an instruction from the Company contravenes applicable data privacy
          laws, BrandGen will notify the Company. However, BrandGen's failure to notify the Company does not relinquish
          any of BrandGen's rights against the Company.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen is authorized to engage sub-processors for processing Company Data on BrandGen's behalf.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>5.4 Data Subject Rights</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            BrandGen commits to making commercially reasonable efforts to help the Company meet its obligations to
            address requests from data subjects who wish to exercise their rights under data privacy laws in relation to
            their data contained in Company Data. This assistance from BrandGen will be provided to the extent that it
            is legally allowed and technically feasible in the given circumstances.
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>5.5 Security Protocols</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen will implement and maintain suitable technical, administrative, and organizational measures to
          safeguard Company Data from unauthorized or illegal processing, taking into account the nature and sensitivity
          of the Company Data.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          5.6 Use of Aggregated Data
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company provides BrandGen with a non-exclusive, transferable, assignable, irrevocable, royalty-free,
          global, perpetual license to generate aggregated and anonymized Company Data ("Aggregated Data"). BrandGen can
          use this Aggregated Data, along with any modifications or derivatives, for its own business purposes. BrandGen
          retains ownership of all Aggregated Data and may transfer or assign its rights in this data to any third
          party.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontSize: "12pt" }}>5.7 Collection of System Data</span>
          </strong>
          <strong> </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company acknowledges that the Platform gathers aggregated and non-personally identifiable data about
          users’ interactions with the Platform, including non-personally identifiable responses to Ads ("System Data").
          This System Data, and all changes made to it, remains the exclusive property of BrandGen. BrandGen is entitled
          to use the System Data for enhancing the Platform, developing new products, services, and features,
          understanding user engagement, and for any other business-related purposes, with no further obligations to the
          Company. BrandGen may also transfer or assign its rights in the System Data to any third party.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>6. Confidentiality</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Under the terms of the Agreement, "Confidential Information" refers to any data related to or contained
            within the Platform, along with non-public information, expertise, and trade secrets in any format, labeled
            as confidential or generally recognized as confidential by a reasonable person. However, the following are
            not included as Confidential Information: data that is or becomes publicly known without violating the
            Agreement, was already lawfully known to the recipient without a confidentiality obligation, is lawfully
            obtained from another source without a confidentiality restriction, is independently developed, or comprises
            feedback or suggestions voluntarily offered about the other party's business, products, or services. The
            parties agree to use this Confidential Information solely for fulfilling their obligations under the
            Agreement. Both parties will avoid sharing any Confidential Information with third parties, except under
            circumstances where: such disclosure is necessary to perform its obligations or exercise its rights under
            the Agreement;
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          a. Disclosure is mandated by law or regulatory guidance. In such cases, the party obligated to disclose must
          make reasonable efforts to notify the other party in advance, allowing them to seek protective measures for
          their Confidential Information. The information disclosed should be limited to what is legally required.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          b. Disclosure is made with the explicit consent of the party that provided the information.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt", textIndent: "36pt" }}>
          i. Disclosure is to Representatives of the disclosing party who require the confidential information to assist
          in fulfilling the obligations under the Agreement.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt", textIndent: "36pt" }}>
          ii. Disclosure is either: i. To the legal counsel of the parties involved; or ii. Confidentially to
          accountants, banks, potential investors, prospective buyers, and their respective advisors and financiers.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>7. Warranty Disclaimer</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The Platform is offered on an "as is" basis without any warranty. BrandGen explicitly disclaims any
            warranties, including but not limited to, those of merchantability, fitness for a specific purpose,
            availability, security, title, and non-infringement. BrandGen will not be held liable for any outcomes
            resulting from the Company's use or misuse of the Platform, including any use that is contrary to law.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>8. Indemnification</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginLeft: "18pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The Company agrees to indemnify, defend, and protect BrandGen and its Representatives against any claims,
            liabilities, damages, losses, and expenses (collectively, "Claims"), including but not limited to reasonable
            legal fees, that arise from any of the following actions or failures to act by the Company:
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          a. Improper use of the Platform; <br />
          b. Fraudulent activities, deliberate misconduct, or extreme negligence; <br />
          c. Non-compliance with legal and regulatory norms relevant to the Company; <br />
          d. Violation of the terms of the Agreement; <br />
          e. Any allegations that the Company's Ads infringe upon applicable laws or regulations; or <br />
          f. Infringement of the rights of others, including but not limited to intellectual property rights.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>9. Limitations on Liability</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Under no circumstances will BrandGen, its affiliates, or their respective agents be held responsible for any
            loss of profits, or for any special, incidental, indirect, exemplary, punitive, or consequential damages of
            any kind, for any reason. This applies whether the liability is based on breach of contract, tort (including
            negligence), or any other grounds, and even if they have been advised of the possibility of such damages.
            Despite any other provisions in the Agreement, BrandGen's total liability to the Company and any third
            parties related to the Agreement or the Company's use of the Platform shall not exceed the total amount paid
            by the Company to BrandGen in the six months preceding the claim or action.
          </span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>10. Term and Termination</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>10.1 Term</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            The Agreement shall commence on the Effective Date, and will remain in full force and effect until and
            unless terminated as set forth herein (
          </span>
          <em>
            <span style={{ fontFamily: '"Times New Roman"' }}>"Term"</span>
          </em>
          <span style={{ fontFamily: '"Times New Roman"' }}>).</span>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>10.2 Termination</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          In line with Section 10.3, BrandGen has the right to terminate the Agreement under the following conditions:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          a. By giving the Company a minimum of thirty (30) days' notice;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          b. With immediate effect upon notification if the Company significantly breaches any of its obligations under
          the Agreement and does not rectify such breach within seven (7) days following a written notice;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginLeft: "36pt", marginBottom: "14pt" }}>
          c. With immediate effect upon notification in case of the Company’s suspension of business, declaration of
          insolvency, initiation of bankruptcy, or liquidation proceedings.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          After any termination for convenience as per subsection (a) above, both parties shall make a sincere effort to
          fulfill any ongoing campaigns or open orders that are acknowledged to exist as of the termination notice date.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>10.3 Immediate Suspension/Termination</span>
          </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Notwithstanding the previous terms, BrandGen reserves the right to suspend or terminate the Agreement and the
          rights granted under it, including for any existing campaigns or open orders as of the termination's effective
          date, without affecting its ability to enforce any other legal right or remedy. This can occur:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          a) Immediately and without notice if the Company fails to fully pay any amount due under the Agreement by the
          specified deadline;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          b) By issuing a written notice of termination in the following situations:
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt", textIndent: "36pt" }}>
          i) If the Company violates BrandGen's intellectual property rights;
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt", textIndent: "36pt" }}>
          ii) If BrandGen suspects that the Company is using the Platform for any improper or illegal purposes, or if
          the Company's Ads are in breach of any Platform policy or applicable laws and regulations.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>10.4 Effect of Termination</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Upon termination of the Agreement, subject to Section 11.12:
          </span>
        </p>
        <ol style={{ margin: "0pt", paddingLeft: "0pt", listStyleType: "lower-latin" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "31.33pt",
              paddingLeft: "4.67pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            all rights of Company under the Agreement will terminate; and
          </li>
          <li
            style={{
              marginLeft: "32pt",
              marginBottom: "14pt",
              paddingLeft: "4pt",
              fontFamily: '"Times New Roman"',
            }}
          >
            BrandGen's obligations relating to the Platform will terminate.
          </li>
        </ol>
        <p style={{ marginTop: "14pt", marginBottom: "14pt", fontSize: "18pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>11. Miscellaneous</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>
            <span style={{ fontFamily: '"Times New Roman"' }}>11.1 Notice</span>
          </strong>
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>
            Notices from one party to another under this Agreement must be delivered either by hand or email to the
            contact details provided on the signature page. Email notices are considered received on the date of
            transmission or receipt, or the next business day if sent outside business hours or on a non-business day.
            Hand-delivered notices are deemed received on the date of delivery. A change of address notice is effective
            only upon confirmed receipt in accordance with this Section 11.1.
          </span>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.2 Marketing and Publicity</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Company cannot release information about its Ads or relationship with BrandGen or its customers, including in
          press releases or promotional materials, without BrandGen's prior written consent. BrandGen may refer to its
          work with the Company for marketing purposes, but mutual consent is required for any public announcements or
          press releases.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.3 Force Majeure</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen is not liable for delays or failures in performance resulting from events beyond its control,
          including strikes, accidents, war, terrorism, disturbances, natural disasters, or utility, communication, or
          computer disruptions. BrandGen will resume its obligations as soon as feasible under these circumstances.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.4 Entire Agreement</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          This Agreement and any related documents constitute the entire agreement on this subject, superseding all
          previous discussions, agreements, and understandings.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.5 Severability</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Should any part of this Agreement be found illegal or unenforceable, the parties will seek a valid replacement
          reflecting their original intent. The remaining provisions remain valid and enforceable.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.6 Further Assurances</strong> <br />
          Each party agrees to take necessary actions, including document execution, to fulfill or continue fulfilling
          the Agreement.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.7 Relationship </strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The parties are independent contractors. Nothing here should be interpreted as forming any agency, employment,
          joint venture, or partnership. Neither party is responsible for the other's actions and cannot obligate the
          other, except as specified in the Agreement.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.8 Governing Law</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Agreement is governed by and construed in accordance with the laws of the Vermont with exclusive
          jurisdiction in its courts.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.9 Waiver</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          A waiver of any breach is not effective unless written, and does not imply a waiver of subsequent breaches.
          Delay or failure to exercise rights does not constitute a waiver.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.10 Assignment</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          The Company cannot assign the Agreement without BrandGen's written consent, and any attempt to do so is void.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.11 Remedies</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          BrandGen may seek injunctive or equitable relief for breaches of confidentiality or proprietary rights, as
          monetary damages may be insufficient.
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <strong>11.12 Survival</strong>
        </p>
        <p className="NormalWeb" style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          Sections 6, 7, 8, 9, and 11 will survive the expiration or termination of the Agreement.
        </p>
        <p style={{ marginTop: "14pt", marginBottom: "14pt" }}>
          <span style={{ fontFamily: '"Times New Roman"' }}>&nbsp;</span>
        </p>
      </>
    </div>
  );
}
